import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Global } from '../../../global/global';
import { SessionService } from 'baseline-lib';



/**
 * Generated class for the BalanceModalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-balance-modal',
  templateUrl: 'balance-modal.html',
})
export class BalanceModalPage {

  constructor(public navCtrl: NavController, public navParams: NavParams,   public globalData : Global,private _sessionService : SessionService,) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad BalanceModalPage');
    let c = this.globalData.authUser.gameTypeBalance;
    console.log(this.globalData.authUser.gameTypeBalance);
    if(this._sessionService.authUser){
      this.globalData.authUser = this._sessionService.authUser;
    }
    
  }

  goBack() {
    this.navCtrl.pop();
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/balance-modal/balance-modal.ts